<app-loading-overlay [isLoading]="isSavingDraft || isSubmittingQuery"></app-loading-overlay>
<div class="main-content">
  <div nz-row>
    <div nz-col nzSpan="18" class="left-section">
      <form nz-form [formGroup]="customQueryFormGroup" nzLayout="vertical">
        <div class="query-panel" *ngIf="!isQueryExpanded">
          <nz-form-item>
            <nz-form-label class="nfl-form-label" nzFor="query-name" nzRequired nzNoColon>Query Name </nz-form-label>
            <ng-container *ngIf="!queryId; else displayName">
              <nz-form-control [nzErrorTip]="nameErrorTemplate">
                <input
                  formControlName="name"
                  id="query-name"
                  nz-input
                  nzSize="default"
                  placeholder="Entry Query Name"
                  maxlength="45"
                  [disabled]="isQueryProcessing"
                />
              </nz-form-control>
            </ng-container>
            <ng-template #displayName>
              <div class="w100">&nbsp;{{ nameFormControl.value }}</div>
            </ng-template>
            <ng-template #nameErrorTemplate let-control>
              <div *ngIf="control?.errors?.['required']">Query name is required.</div>
              <div *ngIf="control?.errors?.['maxlength']">
                Query name cannot exceed
                {{ control?.errors?.['maxlength'].requiredLength }} characters.
              </div>
              <div *ngIf="control?.errors?.['pattern']">
                Query name should not contain any special characters and should have at least one alphabet.
              </div>
            </ng-template>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label class="nfl-form-label" nzFor="query-description" nzRequired nzNoColon>
              Query Description
            </nz-form-label>
            <ng-container *ngIf="!queryId; else displayDescription">
              <nz-form-control [nzErrorTip]="descriptionErrorTemplate">
                <textarea
                  appTrimFormInput
                  id="query-description"
                  formControlName="description"
                  nz-input
                  placeholder="Entry Query Description"
                  [nzAutosize]="{ minRows: 2, maxRows: 6 }"
                  [attr.disabled]="!queryId || isQueryProcessing ? '' : null"
                ></textarea>
                <ng-template #descriptionErrorTemplate let-control>
                  <div *ngIf="control?.errors?.['required']">Please enter the query description.</div>
                  <div *ngIf="control?.errors?.['maxlength']">
                    Description cannot exceed
                    {{ control?.errors?.['maxlength'].requiredLength }} characters.
                  </div>
                  <div *ngIf="control?.errors?.['pattern']">Description should contain at least one alphabet</div>
                </ng-template>
              </nz-form-control>
            </ng-container>
            <ng-template #displayDescription>
              <div>&nbsp;{{ descriptionFormControl.value }}</div>
            </ng-template>
          </nz-form-item>
        </div>
        <nz-form-item>
          <nz-form-label *ngIf="!isQueryExpanded" class="nfl-form-label" nzRequired nzNoColon>Query </nz-form-label>
          <nz-form-control [nzErrorTip]="queryErrorTemplate">
            <div class="query-editor-wrapper" (keydown)="onKeyDown($event)">
              <app-monaco-editor
                #queryEditor
                appTrimFormInput
                [expanded]="isQueryExpanded"
                [readOnly]="isQueryProcessing"
                formControlName="query"
              ></app-monaco-editor>
              <button
                nz-button
                nzType="default"
                type="button"
                class="expand-btn"
                [disabled]="isQueryProcessing"
                (click)="toggleQueryExpanded()"
              >
                <span nz-icon [nzType]="isQueryExpanded ? 'compress' : 'expand'" nzTheme="outline"></span>
              </button>
            </div>
            <ng-template #queryErrorTemplate let-control>
              <div *ngIf="control?.errors?.['required']">Please enter the query.</div>
              <div *ngIf="control?.errors?.['maxlength']">
                Query cannot exceed
                {{ control?.errors?.['maxlength'].requiredLength }} characters.
              </div>
              <div *ngIf="control?.errors?.['pattern']">Query should contain at least one alphabet</div>
            </ng-template>
          </nz-form-control>
        </nz-form-item>

        <div class="action-btn" *ngIf="!isQueryExpanded">
          <button
            nz-button
            nzType="default"
            nzSize="large"
            type="button"
            class="generate-button disabled-btn"
            (click)="handleValidate()"
            [nzLoading]="spinningState === 'validate'"
            [disabled]="customQueryFormGroup.invalid || isLoading || checkValidationStatus"
          >
            Validate Query
          </button>
          <!--hide draft button for now-->
          <button
            *ngIf="false"
            nz-button
            nzType="default"
            nzSize="large"
            type="button"
            class="generate-button disabled-btn"
            [disabled]="customQueryFormGroup.invalid || isSavingDraft || isSubmittingQuery"
            [nzLoading]="isSavingDraft"
            (click)="onSaveAsDraftClick()"
          >
            Save as Drafts
          </button>
          <button
            nz-button
            nzType="default"
            nzSize="large"
            type="button"
            class="generate-button disabled-btn"
            [disabled]="customQueryFormGroup.invalid || isLoading || !checkValidationStatus"
            [nzLoading]="isSubmittingQuery"
            [nzLoading]="spinningState === 'submit'"
            (click)="onValidateAndRunClick()"
          >
            Run Query
          </button>
        </div>
        <div *ngIf="!isQueryExpanded">
          <nz-form-label class="nfl-form-label" nzFor="validation-logs" nzNoColon>Validation Logs </nz-form-label>
          <div class="validation-result">
            <p nz-typography *ngIf="!(validationLogs?.errors?.length || 0) && !validationException" nzType="success">
              {{ validationLogs?.message }}
            </p>
            <ng-container *ngIf="validationLogs?.warnings?.length || 0">
              <span nz-typography>Warnings</span>
              <div *ngFor="let warning of validationLogs?.warnings">
                <p nz-typography nzType="warning">
                  {{ warning }}
                </p>
              </div>
            </ng-container>
            <ng-container *ngIf="validationLogs?.errors?.length || 0">
              <span nz-typography>Errors</span>
              <div *ngFor="let error of validationLogs?.errors">
                <p
                  nz-typography
                  nzType="danger"
                  (click)="onAthenaErrorClick(error)"
                  [ngStyle]="isClickableError(error) ? { cursor: 'pointer', 'text-decoration': 'underline' } : {}"
                >
                  {{ error }}
                </p>
              </div>
            </ng-container>
            <ng-container *ngIf="validationException">
              <span nz-typography>Exception</span>
              <div>
                <p nz-typography nzType="danger">
                  {{ validationException }}
                </p>
              </div>
            </ng-container>
          </div>
        </div>
      </form>
    </div>
    <div nz-col nzSpan="6" class="right-section">
      <h3>Database Schema</h3>
      <div class="database-schema-panel">
        <form nz-form nzLayout="vertical">
          <nz-form-item>
            <nz-form-label class="nfl-form-label">Data Source</nz-form-label>
            <nz-form-control nzErrorTip="Please select the data source.">
              <nz-select
                nzPlaceHolder="Select Data Source"
                nzSize="default"
                [nzMaxTagCount]="2"
                [nzMaxTagPlaceholder]="datasourcePlaceholder"
                nzMode="multiple"
                [formControl]="selectedDatasources"
                [nzDisabled]="isQueryProcessing || isMetadataLoading || !dataSourceList.length"
              >
                <nz-option
                  [nzLabel]="datasource"
                  [nzValue]="datasource"
                  *ngFor="let datasource of dataSourceList; index as i"
                ></nz-option>
              </nz-select>
              <ng-template #datasourcePlaceholder let-selectedList>
                and {{ selectedList.length }} more selected
              </ng-template>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label class="nfl-form-label">Database</nz-form-label>
            <nz-form-control nzErrorTip="Please select the database.">
              <nz-select
                nzPlaceHolder="Select Database"
                nzSize="default"
                [nzMaxTagCount]="2"
                [nzMaxTagPlaceholder]="databasePlaceholder"
                nzMode="multiple"
                [formControl]="selectedDatabases"
                [nzNotFoundContent]="noDatabaseTemplate"
                [nzDisabled]="isQueryProcessing || isMetadataLoading || !databaseList.length"
              >
                <nz-option
                  *ngFor="let database of databaseList; index as i"
                  [nzLabel]="database"
                  [nzValue]="database"
                ></nz-option>
              </nz-select>
              <ng-template #databasePlaceholder let-selectedList>
                and {{ selectedList.length }} more selected
              </ng-template>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item nzLayout="vertical">
            <nz-form-label class="nfl-form-label">Tables And Schema(s)</nz-form-label>
            <div class="db-table-section" *ngIf="tableList.length; else metadataStateTemplate">
              <nz-collapse nzAccordion nzSize="small">
                <nz-collapse-panel
                  [nzScroll]="{ x: '98.75rem' }"
                  [nzShowArrow]="false"
                  *ngFor="let table of tableList; index as i"
                  [nzHeader]="tableHeader"
                >
                  <div class="table-columns" *ngFor="let item of table.columns; index as j">
                    <span class="column-name" nz-typography [nz-tooltip]="item.name || '-'">
                      {{ item.name || '-' }}
                    </span>
                    <span class="column-type">{{ item.type || '-' }}</span>
                  </div>
                  <ng-template #tableHeader>
                    <div class="table-header">
                      <span class="table-icon" aria-label="Database" role="img"></span>
                      <div class="table-details">
                        <span class="title-text" nz-typography [nz-tooltip]="table.tableName">
                          <span class="table-name">{{ table.tableName }}</span>
                        </span>
                        <div class="table-tags">
                          <nz-tag nzColor="success" [nz-tooltip]="table.datasourceName">
                            {{ table.datasourceName }}
                          </nz-tag>
                          <nz-tag nzColor="warning" [nz-tooltip]="table.databaseName">
                            {{ table.databaseName }}
                          </nz-tag>
                        </div>
                      </div>
                      <button
                        nz-button
                        nzType="link"
                        type="button"
                        class="glossary-button"
                        aria-label="Open data glossary"
                        nz-tooltip
                        nzTooltipTitle="Open data glossary"
                        (click)="openGlossary(table); $event.stopPropagation()"
                      >
                        <span nz-icon nzType="read" nzTheme="outline"></span>
                      </button>
                    </div>
                  </ng-template>
                </nz-collapse-panel>
              </nz-collapse>
            </div>
          </nz-form-item>
        </form>
      </div>
    </div>
  </div>
</div>

<ng-template #glossaryTitle>
  <div class="glossary-header">
    <h2>
      <span class="glossary-title-icon" nz-icon nzType="read" nzTheme="outline"></span>
      Data Glossary
    </h2>
  </div>
</ng-template>

<nz-modal
  [(nzVisible)]="isGlossaryVisible"
  [nzFooter]="null"
  [nzTitle]="glossaryTitle"
  [nzWidth]="900"
  nzCentered
  (nzOnCancel)="closeGlossary()"
>
  <ng-container *nzModalContent>
    <nz-alert
      nzType="info"
      nzShowIcon
      [nzMessage]="selectedTable?.tableDescription || 'No table description available.'"
    ></nz-alert>

    <div class="glossary-content">
      <div class="glossary-toolbar">
        <div class="table-title">Data Elements ({{ selectedTable?.tableName }})</div>

        <div class="search-box">
          <nz-input-group nzPrefixIcon="search">
            <input nz-input placeholder="Search data elements..." [(ngModel)]="searchText" />
          </nz-input-group>
        </div>
      </div>

      <nz-table
        #basicTable
        [nzData]="filteredColumns"
        [nzFrontPagination]="false"
        [nzShowPagination]="false"
        [nzScroll]="{ y: 'min(360px, calc(100vh - 360px))' }"
        nzSize="small"
      >
        <thead>
          <tr>
            <th>Data Element</th>
            <th>Definition</th>
            <th class="data-type-column">Data Type</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let column of basicTable.data">
            <td>{{ column.name || '-' }}</td>
            <td>{{ column.description || '-' }}</td>
            <td class="data-type-column">
              <nz-tag>{{ column.type || '-' }}</nz-tag>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>

    <div class="modal-footer">
      <button nz-button nzType="default" type="button" (click)="closeGlossary()">Close</button>
    </div>
  </ng-container>
</nz-modal>

<ng-template #metadataStateTemplate>
  <div class="metadata-state">
    <p nz-typography *ngIf="isMetadataLoading">Loading metadata details...</p>
    <p nz-typography *ngIf="!isMetadataLoading && metadataErrorMessage">{{ metadataErrorMessage }}</p>
    <p nz-typography *ngIf="!isMetadataLoading && !metadataErrorMessage">
      Select a data source and database to view schema details.
    </p>
  </div>
</ng-template>

<ng-template #noDatabaseTemplate>
  <div class="metadata-state">
    <p nz-typography *ngIf="isMetadataLoading">Loading metadata details...</p>
    <p nz-typography *ngIf="!isMetadataLoading && metadataErrorMessage">{{ metadataErrorMessage }}</p>
    <p nz-typography *ngIf="!isMetadataLoading && !metadataErrorMessage">
      Please select the data source to get the databases.
    </p>
  </div>
</ng-template>
